"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const SessionContext_1 = require("../context/SessionContext");
const SelectionContext_1 = require("../context/SelectionContext");
const SessionBuilderContext_1 = require("../context/SessionBuilderContext");
const LayoutSelector_1 = require("../LayoutSelector");
const api_1 = require("../api");
const TemplateCreatePage = () => {
    return ((0, jsx_runtime_1.jsx)(SessionContext_1.SessionProvider, { builderId: "new", docType: api_1.DOC_TYPE.PPT, children: (0, jsx_runtime_1.jsx)(SelectionContext_1.SelectionProvider, { children: (0, jsx_runtime_1.jsx)(SessionBuilderContext_1.SessionBuilderProvider, { sessionId: "new", docType: api_1.DOC_TYPE.PPT, newTemplateGenerate: true, children: (0, jsx_runtime_1.jsx)(LayoutSelector_1.LayoutSelector, { newTemplateGenerate: true }) }) }) }));
};
exports.default = TemplateCreatePage;
